import { create } from 'zustand';
import { ProductConditionType, ProductLine } from 'types';

interface ProductState {
  currentProduct: ProductLine | null;
  setCurrentProduct: (product: ProductLine | null) => void;
  isProductNew: boolean | null;
  setProductNew: (isNew: boolean | null) => void;
  productCondition: ProductConditionType | null;
  setProductCondition: (condition: ProductConditionType | null) => void;
  productId: string;
  setProductId: (id: string) => void;
  showGradingSheet: boolean;
  setShowGradingSheet: (show: boolean) => void;
  isRejected: boolean;
  setIsRejected: (v: boolean) => void;
  toggleIsRejected: () => void;
  reset: () => void;
}

export const useProductStore = create<ProductState>((set) => ({
  currentProduct: null,
  setCurrentProduct: (product: ProductLine | null) => set({ currentProduct: product }),
  isProductNew: null,
  productCondition: null,
  setProductCondition: (condition: ProductConditionType | null) =>
    set({ productCondition: condition }),
  setProductNew: (isNew: boolean | null) => set({ isProductNew: isNew }),
  productId: '',
  setProductId: (id: string) => set({ productId: id }),
  showGradingSheet: false,
  setShowGradingSheet: (show: boolean) => set({ showGradingSheet: show }),
  isRejected: false,
  setIsRejected: (v: boolean) => set({ isRejected: v }),
  toggleIsRejected: () => set((s) => ({ isRejected: !s.isRejected })),
  reset: () =>
    set({
      currentProduct: null,
      isProductNew: null,
      productCondition: null,
      showGradingSheet: false,
      isRejected: false,
    }),
}));
